Immutable = require 'seamless-immutable'
{ did, doing } = require './common'
{
	CREATED_CLASSROOM,
	CREATING_CLASSROOM,
	DELETED_CLASSROOM,
	DELETING_CLASSROOM,
	FETCHED_CLASSROOM,
	FETCHED_CLASSROOMS,
	FETCHED_INSTRUCTORS,
	FETCHED_TEACHERS,
	FETCHING_CLASSROOM,
	FETCHING_CLASSROOMS,
	FETCHING_INSTRUCTORS,
	FETCHING_TEACHERS,
	GROUPED_STUDENTS,
	GROUPING_STUDENTS,
	SELECT_CLASSROOM,
	UPDATED_CLASSROOM,
	UPDATING_CLASSROOM
} = require '../actions/classrooms'

baseState = Immutable {
	list: []
	instructors: []
	isCreating: false
	isDeleting: false
	isFetching: false
	isFetchingOne: false
	isFetchingInstructors: false
	isFetchingTeachers: false
	isGrouping: false
	isUpdating: false
	selected: null
}

classrooms = (state = baseState, action) ->
	switch action.type
		when CREATING_CLASSROOM
			state = doing 'isCreating', state
		when CREATED_CLASSROOM
			state = did 'isCreating', state, action
		when DELETING_CLASSROOM
			state = doing 'isDeleting', state
		when DELETED_CLASSROOM
			state = did 'isDeleting', state, action
		when FETCHING_CLASSROOM
			state = doing 'isFetchingOne', state
		when FETCHED_CLASSROOM
			localStorage.setItem 'classroom', action.payload.classroom.id
			state = state.set 'isFetchingOne', false
			state = state.set 'selected', action.payload.classroom unless action.error
		when FETCHING_INSTRUCTORS
			state = doing 'isFetchingInstructors', state
		when FETCHED_INSTRUCTORS
			state = state.set 'isFetchingInstructors', false
			state = state.set 'instructors', action.payload.list unless action.error
		when FETCHING_TEACHERS
			state = doing 'isFetchingTeachers', state
		when FETCHED_TEACHERS
			state = state.set 'isFetchingTeachers', false
			state = state.set 'teachers', action.payload.list unless action.error
		when FETCHING_CLASSROOMS
			state = doing 'isFetching', state
		when FETCHED_CLASSROOMS
			state = did 'isFetching', state, action
		when GROUPING_STUDENTS
			state = doing 'isGrouping', state
		when GROUPED_STUDENTS
			state = state.set 'isGrouping', false
			state = state.set 'selected', action.payload.classroom unless action.error
		when SELECT_CLASSROOM
			if action.payload.classroom
				localStorage.setItem 'classroom', action.payload.classroom.id
			else
				localStorage.removeItem 'classroom'

			state = state.set('selected', action.payload.classroom)
		when UPDATING_CLASSROOM
			state = doing 'isUpdating', state
		when UPDATED_CLASSROOM
			state = state.set 'isGrouping', false
			unless action.error
				state = state.set 'selected', action.payload.classroom
				state = state.set 'list', action.payload.list
	state

module.exports = classrooms




// WEBPACK FOOTER //
// ./frontend/olos/js/reducers/classrooms.coffee